<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.alefcafe.com\/storage\/content\/pat2.png\");\n\n"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.baghirani.mxit.ir\/storage\/assets\/logo.png","alt":""},...{}}' :style='"height: 300px;\nobject-fit: contain;"' class="col-12 " ></m-img><m-div v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-products-302 v-bind='{...{"paginate":false,"perPage":35,"productCardName":"mProductCard302","showSpecifiedCardFeature":""},...{}}' :style='""' class="container mb-5 pb-5" ></m-products-302></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-bottom:110px;\nmargin-top:80px;\nborder-radius: 120px 120px 0px 0px ;\nbackground-color:var(--secondary);\nposition:relative;\n"' class="container-fluid p-0  shadow" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding:120px 32px;\nmargin: 0  16px;\n"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center align-items-top" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4  text-center col-md-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.baghirani.mxit.ir\/storage\/assets\/logo.png","alt":""},...{}}' :style='"height:200px;"' class="img-fluid py-2 mb-4 " ></m-img><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کافه باغ ایرانی    </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"telephone"},...{}}' :style='""' class="h5 text-primary mx-2" ></m-icon><m-a v-bind='{...{"href":"tel:09367452149","target":"_self"},...{}}' :style='"direction: ltr;"' class="caption" >
                <template #default>09367452149   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-2" >
                <template #default>   <m-icon v-bind='{...{"icon":"geo-alt"},...{}}' :style='""' class="h5 text-primary mx-2" ></m-icon><m-p v-bind='{...{},...{}}' :style='""' class="d-inline text-caption" >
                <template #default>خیابان ساحلی شمالی - جنب کاشفیه (روبروی گلباران)   </template>
                </m-p></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4  text-center col-md-6 text-lg-right" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="footer-title" >
                <template #default>نقشه   </template>
                </m-h3><m-img v-bind='{...{"src":"https:\/\/api.baghirani.mxit.ir\/storage\/icons\/Screenshot-(31).png","alt":"mix it web"},...{}}' :style='""' class="img-fluid" ></m-img></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"border-top:1px solid #CCCCCC;\npadding: 20px 0;"' class="row mx-auto justify-content-around mt-5 align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4 text-lg-right text-center pt-2" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تمامی حقوق برای کافه باغ ایرانی محفوظ است   </template>
                </m-span></template>
                </m-div><m-a v-bind='{...{"href":"https:\/\/mixitweb.com","target":"_self"},...{}}' :style='""' class="mt-3" >
                <template #default>ساخته شده با  ❤ توسط mixitweb   </template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4  text-lg-left text-center pt-2" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/www.instagram.com\/payam_cafe_game","target":"_self"},...{}}' :style='""' class="pr-1 footer-logo" >
                <template #default>   <m-icon v-bind='{...{"icon":"instagram"},...{}}' :style='""' class="h2 mx-3" ></m-icon></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/dash.baghirani.mxit.ir\/dashboard","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"person"},...{}}' :style='""' class="h2" ></m-icon></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mProducts302 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products302/Products302'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mProducts302,mP,mIcon,mA,mH3,mSpan },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
